

/** Tabs inside one serial. All four are scoped to the selected version, no exceptions. */
export type SerialTab = 'findings' | 'resources' | 'policy' | 'providers'

export const SERIAL_TABS: { key: SerialTab; label: string }[] = [
  { key: 'findings',  label: 'Findings' },
  { key: 'resources', label: 'Resource Inspector' },
  { key: 'policy',    label: 'Policy' },
  { key: 'providers', label: 'Providers in use' },
]
